import { render, staticRenderFns } from "./AssignTutor.vue?vue&type=template&id=0ac073ed"
import script from "./AssignTutor.vue?vue&type=script&lang=js"
export * from "./AssignTutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports